export const EWI_COLORS = ['', 'black', 'white', 'magenta', 'blue', 'green'];
export const EWI_BACKGROUNDS = ['dark', 'light', 'lightblue', 'lightgrey'];
export const EWI_ICONS = ['leaf', 'house', 'phone', 'smiley'];
export const EWI_BUTTON_TYPES = [
  'filled',
  'outlined',
  'elevated',
  'text',
  'tonal',
];
